var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.418 5.33398H6.08464C4.61797 5.33398 3.41797 6.53398 3.41797 8.00065V24.0007C3.41797 25.4673 4.61797 26.6673 6.08464 26.6673H27.418C28.8846 26.6673 30.0846 25.4673 30.0846 24.0007V8.00065C30.0846 6.53398 28.8846 5.33398 27.418 5.33398ZM16.7513 9.00065C18.4046 9.00065 19.7513 10.3473 19.7513 12.0007C19.7513 13.654 18.4046 15.0007 16.7513 15.0007C15.098 15.0007 13.7513 13.654 13.7513 12.0007C13.7513 10.3473 15.098 9.00065 16.7513 9.00065ZM23.418 22.6673H10.0846V20.6673C10.0846 18.4407 14.5246 17.334 16.7513 17.334C18.978 17.334 23.418 18.4407 23.418 20.6673V22.6673Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleContact);
export default __webpack_public_path__ + "static/media/singleContact.f51de61b5f8a9c09ad5d3ad32c435f0b.svg";
export { ForwardRef as ReactComponent };